<template>
    <div class="main_div">
        <div style="height: auto" :key="componentKey">
            <n-space>
                <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
                    <n-space item-style="display: flex;" align="center">
                        <div style="font-size: 20px; width: 150px; font-weight: bold">개인용 상품 관리</div>
                    </n-space>
                    <div class="content_delimiter_line"></div>
                    <Loading v-show="loading" />
                    <div>
                        <button @click="openGroupRegistrationModal" class="action-button">신규 상품 등록</button>
                        <div v-if="listLoading" class="loading-indicator">상품 목록을 불러오는 중...</div>
                        <!-- <div v-if="error" class="error-message">{{ error }}</div> -->
                        <div v-else>
                            <div class="table-container">
                                <n-data-table
                                    v-if="productGroups.length > 0"
                                    :columns="columns"
                                    :data="productGroups"
                                    :pagination="false"
                                    :bordered="true"
                                />
                                <p v-else>등록된 상품이 없습니다.</p>
                            </div>
                            <div
                                v-if="productGroups.length > 0"
                                class="pagination-controls"
                                style="margin-top: 15px; text-align: center"
                            >
                                <n-button
                                    @click="wrappedGoToPreviousPage"
                                    :disabled="currentPage === 1"
                                    style="margin-right: 8px"
                                >
                                    이전 페이지
                                </n-button>
                                <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                                <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                            </div>
                        </div>
                    </div>
                </NCard>

                <n-modal
                    v-model:show="showDetailsModal"
                    preset="card"
                    style="width: 600px"
                    title="진단 상품 상세 정보"
                    @after-leave="onDetailsModalClose"
                >
                    <div v-if="selectedProductGroup" class="organization-details-content">
                        <n-descriptions label-placement="left" bordered :column="1" size="small">
                            <n-descriptions-item label="상품코드">
                                {{ selectedProductGroup.product_key }}
                            </n-descriptions-item>
                            <n-descriptions-item label="상품명">
                                {{ selectedProductGroup.name }}
                            </n-descriptions-item>
                            <n-descriptions-item label="가격">
                                {{ selectedProductGroup.price?.toLocaleString() }} 원
                            </n-descriptions-item>
                            <n-descriptions-item label="설명">
                                {{ selectedProductGroup.description || "N/A" }}
                            </n-descriptions-item>
                            <n-descriptions-item label="상태">
                                {{ selectedProductGroup.status ? selectedProductGroup.status : "판매중" }}
                            </n-descriptions-item>
                        </n-descriptions>
                        <h4 style="margin-top: 20px; margin-bottom: 10px">포함된 상품 목록</h4>
                        <div v-if="selectedProductGroup.products && selectedProductGroup.products.length > 0">
                            <n-data-table
                                :columns="itemColumns"
                                :data="selectedProductGroup.products"
                                :pagination="false"
                                :bordered="true"
                                size="small"
                            />
                        </div>
                        <div v-else style="text-align: center; padding: 20px; color: #888">포함된 상품이 없습니다.</div>
                        <div style="text-align: right; margin-top: 20px">
                            <n-button @click="closeDetailsModal" type="primary">닫기</n-button>
                        </div>
                    </div>
                </n-modal>

                <!-- 신규 상품 등록 모달 -->
                <n-modal
                    v-model:show="showGroupRegistrationModal"
                    preset="card"
                    style="width: 700px"
                    title="신규 상품 등록"
                    @after-leave="onGroupRegistrationModalClose"
                >
                    <n-form
                        ref="groupRegistrationFormRef"
                        :model="groupRegistrationModel"
                        :rules="groupRegistrationRules"
                        label-placement="left"
                        label-width="auto"
                        require-mark-placement="right-hanging"
                    >
                        <n-form-item label="상품코드" path="product_key">
                            <n-input v-model:value="groupRegistrationModel.product_key" placeholder="상품코드" />
                        </n-form-item>
                        <n-form-item label="상품명" path="name">
                            <n-input v-model:value="groupRegistrationModel.name" placeholder="상품명" />
                        </n-form-item>
                        <n-form-item label="가격" path="price">
                            <n-input-number
                                v-model:value="groupRegistrationModel.price"
                                placeholder="가격"
                                style="width: 100%"
                                :min="0"
                            />
                        </n-form-item>
                        <n-form-item label="설명" path="description">
                            <n-input
                                v-model:value="groupRegistrationModel.description"
                                type="textarea"
                                placeholder="상품에 대한 설명 (선택 사항)"
                            />
                        </n-form-item>

                        <n-form-item label="상품 선택" path="products">
                            <n-space vertical style="width: 100%">
                                <n-space>
                                    <n-select
                                        v-model:value="selectedProductCategory"
                                        placeholder="카테고리를 선택하세요"
                                        :options="productCategories"
                                        label-field="label"
                                        value-field="value"
                                        clearable
                                        style="width: 180px"
                                    />
                                    <n-select
                                        v-model:value="tempSelectedOrgProductId"
                                        placeholder="상품을 선택하세요"
                                        :options="organizationProductsOptions"
                                        label-field="name"
                                        value-field="SK"
                                        filterable
                                        clearable
                                        :disabled="!selectedProductCategory"
                                        style="width: 400px"
                                    />
                                    <n-button
                                        @click="addSelectedProductToGroup(false)"
                                        :disabled="!tempSelectedOrgProductId"
                                        >추가</n-button
                                    >
                                </n-space>
                                <div
                                    v-if="orgProductLoading && organizationProducts.length === 0"
                                    style="margin-top: 5px; color: #888"
                                >
                                    상품 목록을 불러오는 중입니다...
                                </div>
                                <div
                                    v-else-if="!orgProductLoading && organizationProducts.length === 0"
                                    style="margin-top: 5px; color: #888"
                                >
                                    등록된 상품이 없습니다. 먼저 상품을 등록해주세요.
                                </div>
                                <n-data-table
                                    v-if="groupRegistrationModel.products.length > 0"
                                    :columns="selectedGroupItemColumns"
                                    :data="groupRegistrationModel.products"
                                    :pagination="false"
                                    :bordered="true"
                                    size="small"
                                    style="margin-top: 10px"
                                />
                            </n-space>
                        </n-form-item>

                        <div style="display: flex; justify-content: flex-end; margin-top: 20px">
                            <n-button
                                @click="showGroupRegistrationModal = false"
                                type="tertiary"
                                style="margin-right: 10px"
                                >취소</n-button
                            >
                            <n-button
                                type="primary"
                                @click="handleGroupRegistrationSubmit"
                                :loading="isGroupRegistering"
                                >등록</n-button
                            >
                        </div>
                    </n-form>
                </n-modal>
                <!-- Edit Product Modal -->
                <n-modal
                    v-model:show="showEditModal"
                    preset="card"
                    style="width: 700px"
                    title="상품 정보 수정"
                    @after-leave="onEditModalClose"
                >
                    <n-form
                        ref="editFormRef"
                        :model="editModel"
                        :rules="editRules"
                        label-placement="left"
                        label-width="auto"
                        require-mark-placement="right-hanging"
                    >
                        <n-form-item label="상품 코드" path="product_key">
                            <n-input v-model:value="editModel.product_key" />
                        </n-form-item>
                        <n-form-item label="상품명" path="name">
                            <n-input v-model:value="editModel.name" placeholder="상품명" />
                        </n-form-item>
                        <n-form-item label="가격" path="price">
                            <n-input-number
                                v-model:value="editModel.price"
                                placeholder="가격"
                                style="width: 100%"
                                :min="0"
                            />
                        </n-form-item>
                        <n-form-item label="설명" path="description">
                            <n-input
                                v-model:value="editModel.description"
                                type="textarea"
                                placeholder="상품에 대한 설명"
                            />
                        </n-form-item>
                        <n-form-item label="상품 선택" path="products">
                            <n-space vertical style="width: 100%">
                                <n-space>
                                    <n-select
                                        v-model:value="selectedProductCategory"
                                        placeholder="카테고리를 선택하세요"
                                        :options="productCategories"
                                        label-field="label"
                                        value-field="value"
                                        clearable
                                        style="width: 180px"
                                    />
                                    <n-select
                                        v-model:value="tempSelectedOrgProductId"
                                        placeholder="상품을 선택하세요"
                                        :options="organizationProductsOptions"
                                        label-field="name"
                                        value-field="SK"
                                        filterable
                                        clearable
                                        :disabled="!selectedProductCategory"
                                        style="width: 400px"
                                    />
                                    <n-button
                                        @click="addSelectedProductToGroup(true)"
                                        :disabled="!tempSelectedOrgProductId"
                                        >추가</n-button
                                    >
                                </n-space>
                                <n-data-table
                                    v-if="editModel.products.length > 0"
                                    :columns="updateSelectedGroupItemColumns"
                                    :data="editModel.products"
                                    :pagination="false"
                                    :bordered="true"
                                    size="small"
                                    style="margin-top: 10px"
                                />
                            </n-space>
                        </n-form-item>
                    </n-form>
                    <div style="text-align: right; margin-top: 20px">
                        <n-button @click="closeEditModal" type="tertiary" style="margin-right: 10px">취소</n-button>
                        <n-button type="primary" @click="handleUpdateSubmit" :loading="isUpdating">확인</n-button>
                    </div>
                </n-modal>
            </n-space>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, h, nextTick, computed } from "vue";
import { getCallable } from "@/config/env";
import {
    NCheckboxGroup,
    NCheckbox,
    NSpace,
    NCard,
    NDataTable,
    NButton,
    NModal,
    NDescriptions,
    NDescriptionsItem,
    NForm,
    NFormItem,
    NInput,
    NInputNumber,
    NInputGroup,
    NSelect,
    FormInst,
    FormRules,
    NIcon,
    NSpin,
    useMessage,
    useNotification,
    useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import * as common from "@/assets/common/common";
import { useAuth } from "@/composables/useAuth";
import { usePagination } from "@/composables/usePagination";
const { loading } = useAuth(); // 전역 로딩 상태
import { Product, ProductGroup } from "@/model/product";

const componentKey = ref(0); // To force re-render if needed
const getProductGroupsCallable = getCallable("getProductGroups");
const updateProductGroupCallable = getCallable("updateProductGroup");
const addProductGroupCallable = getCallable("addProductGroup");
const getOrganizationProductsCallable = getCallable("getProducts");

const tempSelectedOrgProductId = ref<string | null>(null);
const selectedProductCategory = ref<string | null>(null);
const organizationProducts = ref<Proudct[]>([]);

const productCategories = ref([
    { label: "진단 검사", value: "personal" },
    { label: "집단분석", value: "org" },
    { label: "상담코칭", value: "offline" },
    { label: "Activity", value: "activity" },
    { label: "전문가교육", value: "expert" },
]);
const organizationProductsOptions = computed(() => {
    if (!selectedProductCategory.value) {
        return [];
    }
    const categoryPrefix = selectedProductCategory.value + "#";
    return organizationProducts.value
        .filter((prod) => prod.SK && prod.SK.startsWith(categoryPrefix))
        .map((prod) => ({
            ...prod,
            disabled: false,
        }));
});

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const router = useRouter();
const orgProductLoading = ref(false);

const {
    paginatedItems: productGroups,
    listLoading,
    error,
    currentPage,
    hasNextPage,
    goToNextPage: composableGoToNextPage,
    goToPreviousPage: composableGoToPreviousPage,
    refreshData: composableRefreshProductGroups,
} = usePagination<ProductGroup>(async (params) => getProductGroupsCallable(params), 10);

async function wrappedRefreshProductGroups() {
    await composableRefreshProductGroups();
}

const selectedProductGroup = ref<ProductGroup | null>(null);
const showDetailsModal = ref<boolean>(false);

const showGroupRegistrationModal = ref(false);
const groupRegistrationFormRef = ref<FormInst | null>(null);
const groupRegistrationModel = ref<{
    product_key: string;
    name: string;
    price: number | null;
    description: string;
    products: Product[];
}>({
    product_key: "",
    name: "",
    price: null,
    description: "",
    products: [],
});
const isGroupRegistering = ref(false);

const groupRegistrationRules: FormRules = {
    product_key: [
        {
            required: true,
            message: "상품코드를 입력해주세요.",
            trigger: ["input", "blur"],
        },
    ],
    name: [
        {
            required: true,
            message: "상품명을 입력해주세요.",
            trigger: ["input", "blur"],
        },
    ],
    price: [
        { required: true, message: "가격을 입력해주세요." },
        {
            type: "number",
            message: "가격은 숫자여야 합니다.",
            trigger: ["input", "blur"],
        },
    ],
    selectedProductIds: [
        {
            type: "array",
            required: true,
            min: 1,
            message: "하나 이상의 상품을 추가해주세요.",
            trigger: "change",
        },
    ],
};

const showEditModal = ref<boolean>(false);
const editFormRef = ref<FormInst | null>(null);
const editModel = ref<Partial<ProductGroup>>({
    SK: "",
    group_id: "",
    name: "",
    price: 0,
    description: "",
    status: "",
    products: [],
});
const isUpdating = ref<boolean>(false);

const editRules: FormRules = {
    name: [
        {
            required: true,
            message: "상품명을 입력해주세요.",
            trigger: ["input", "blur"],
        },
    ],
    price: [
        { required: true, message: "가격을 입력해주세요." },
        { type: "number", message: "가격은 숫자여야 합니다." },
    ],
};

const columns = [
    {
        title: "상품코드",
        key: "product_key",
        resizable: true,
    },
    {
        title: "상품명",
        key: "name",
        resizable: true,
    },
    {
        title: "가격",
        key: "price",
        resizable: true,
        render(row: Product) {
            return common.formatNumberWithCommas(row.price);
        },
    },
    {
        title: "상태",
        key: "status",
        resizable: true,
        render(row: ProductGroup) {
            if (!row.status) {
                return "판매중";
            } else {
                // TODO : 아직은 상태 값이 정해지지 않았음.
                return row.status;
            }
        },
    },
    {
        title: "상세보기",
        key: "actions",
        render(row: ProductGroup) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "small",
                    onClick: () => displayProductGroupDetails(row, false),
                },
                { default: () => "상세" }
            );
        },
    },
    {
        title: "정보 수정",
        key: "actions",
        render(row: ProductGroup) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "small",
                    onClick: () => displayProductGroupDetails(row, true),
                },
                { default: () => "수정" }
            );
        },
    },
];

const itemColumns = [
    { title: "상품명", key: "name" },
    { title: "타입", key: "type" },
];

const selectedGroupItemColumns = [
    { title: "상품명", key: "name", width: 200 },
    {
        title: "삭제",
        key: "actions",
        width: 60,
        align: "center" as const,
        render(row: Product) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "tiny",
                    type: "error",
                    onClick: () => removeProductFromGroup(row.SK!, false),
                },
                { default: () => "삭제" }
            );
        },
    },
];

const updateSelectedGroupItemColumns = [
    { title: "상품명", key: "name", width: 200 },
    {
        title: "삭제",
        key: "actions",
        width: 60,
        align: "center" as const,
        render(row: Product) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "tiny",
                    type: "error",
                    onClick: () => removeProductFromGroup(row.SK!, true),
                },
                { default: () => "삭제" }
            );
        },
    },
];

async function wrappedGoToNextPage() {
    if (!hasNextPage.value) return;
}

async function wrappedGoToPreviousPage() {
    if (currentPage.value <= 1) return;
    await composableGoToPreviousPage();
}

function displayProductGroupDetails(productGroup: ProductGroup, isUpdate = false) {
    error.value = null;
    selectedProductGroup.value = productGroup;
    if (isUpdate) openEditModal(productGroup);
    else showDetailsModal.value = true;
}

function openEditModal(productGroup: ProductGroup) {
    editModel.value = { ...productGroup };
    if (!editModel.value.products) editModel.value.products = [];
    showEditModal.value = true;
    nextTick(() => {
        editFormRef.value?.restoreValidation();
    });
}

function closeDetailsModal() {
    showDetailsModal.value = false;
}

function onDetailsModalClose() {}

function onGroupRegistrationModalClose() {
    showGroupRegistrationModal.value = false;
    isGroupRegistering.value = false;
    tempSelectedOrgProductId.value = null;
}

function closeEditModal() {
    showEditModal.value = false;
}

function onEditModalClose() {
    editModel.value = {
        SK: "",
        group_id: "",
        product_key: "",
        name: "",
        price: 0,
        description: "",
        status: "",
        products: [],
    };
    isUpdating.value = false;
}

async function fetchOrganizationProducts() {
    orgProductLoading.value = true;
    try {
        const result = await getOrganizationProductsCallable();
        if (common.evalFunctionResult(result) && result.data) {
            const data = common.getItemListFromFunctionResult(result);
            organizationProducts.value = data as Product[];
        } else {
            notification.error({
                title: "오류",
                content: `상품 목록 로드 실패: ${common.getResultError(result)}`,
                duration: 3000,
            });
            organizationProducts.value = [];
        }
    } catch (error: any) {
        notification.error({
            title: "오류",
            content: `상품 목록 로드 중 예외 발생: ${error.message}`,
            duration: 3000,
        });
        organizationProducts.value = [];
    } finally {
        orgProductLoading.value = false;
    }
}

function openGroupRegistrationModal() {
    groupRegistrationModel.value = {
        product_key: "",
        name: "",
        price: null,
        description: "",
        products: [],
    };
    tempSelectedOrgProductId.value = null;
    groupRegistrationFormRef.value?.restoreValidation();
    showGroupRegistrationModal.value = true;
}

function addSelectedProductToGroup(isEdit: boolean = false) {
    if (!tempSelectedOrgProductId.value) return;
    const productToAdd = organizationProducts.value.find((p) => p.SK === tempSelectedOrgProductId.value);
    if (productToAdd) {
        if (!isEdit) {
            if (!groupRegistrationModel.value.products.find((p) => p.SK === productToAdd.SK)) {
                groupRegistrationModel.value.products.push({ ...productToAdd });
            } else {
                message.warning("이미 추가된 상품입니다.");
            }
        } else {
            if (!editModel.value.products.find((p) => p.SK === productToAdd.SK)) {
                editModel.value.products.push({ ...productToAdd });
            } else {
                message.warning("이미 추가된 상품입니다.");
            }
        }
    }
    tempSelectedOrgProductId.value = null;
}

function removeProductFromGroup(productSK: string, isEdit: boolean = false) {
    if (!isEdit) {
        groupRegistrationModel.value.products = groupRegistrationModel.value.products.filter((p) => p.SK !== productSK);
    } else {
        editModel.value.products = editModel.value.products.filter((p) => p.SK !== productSK);
    }
}

async function handleGroupRegistrationSubmit() {
    try {
        await groupRegistrationFormRef.value?.validate();
    } catch (errors) {
        message.error("입력 내용을 확인해주세요.");
        return;
    }

    if (groupRegistrationModel.value.products.length === 0) {
        message.error("포함할 상품을 하나 이상 추가해주세요.");
        return;
    }
    isGroupRegistering.value = true;
    try {
        const productsForPayload = groupRegistrationModel.value.products.map((p) => ({
            ...p,
        }));

        const payload: Partial<ProductGroup> = {
            product_key: groupRegistrationModel.value.product_key,
            name: groupRegistrationModel.value.name,
            price: Number(groupRegistrationModel.value.price),
            description: groupRegistrationModel.value.description,
            products: productsForPayload,
        };

        const result = await addProductGroupCallable(payload);

        if (common.evalFunctionResult(result)) {
            message.success("상품이 성공적으로 등록되었습니다.");
            showGroupRegistrationModal.value = false;
            await wrappedRefreshProductGroups();
        } else {
            notification.error({
                title: "등록 실패",
                content: `상품 등록 중 오류 발생: ${common.getResultError(result) || "알 수 없는 오류"}`,
                duration: 3000,
            });
        }
    } catch (err: any) {
        console.error("상품 등록 API 호출 실패:", err);
        notification.error({
            title: "등록 실패",
            content: `상품 등록 중 심각한 오류 발생: ${err.message || "서버 통신 오류"}`,
            duration: 3000,
        });
    } finally {
        isGroupRegistering.value = false;
    }
}

async function handleUpdateSubmit() {
    try {
        await editFormRef.value?.validate();
    } catch (errors) {
        message.error("입력 내용을 확인해주세요.");
        return;
    }

    if (!editModel.value.SK && !editModel.value.group_id) {
        message.error("수정할 상품 정보가 올바르지 않습니다.");
        return;
    }
    isUpdating.value = true;
    try {
        const payload = { ...editModel.value };
        const result = await updateProductGroupCallable(payload as ProductGroup);

        if (common.evalFunctionResult(result)) {
            message.success("상품 정보가 성공적으로 수정되었습니다.");
            closeEditModal();
            await wrappedRefreshProductGroups();
        } else {
            notification.error({
                title: "수정 실패",
                description: `상품 정보 수정 중 오류 발생: ${common.getResultError(result) || "알 수 없는 오류"}`,
                duration: 3000,
            });
        }
    } catch (err: any) {
        console.error("상품 수정 API 호출 실패:", err);
        notification.error({
            title: "수정 실패",
            description: `상품 정보 수정 중 심각한 오류 발생: ${err.message || "서버 통신 오류"}`,
            duration: 3000,
        });
    } finally {
        isUpdating.value = false;
    }
}

onMounted(async () => {
    await fetchOrganizationProducts();
    wrappedRefreshProductGroups();
});
</script>

<style scope></style>
